import { Trans } from '@lingui/react/macro';

import Badge from '@/design_system/Badge';
import IconDone from '@/icons/Done.svg';
import { isCustom } from '@/models/actionType';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import useViewPort from '@/utils/useViewport';

export const AutoAcceptBadge = () => {
  const { isMobile, isTablet } = useViewPort();
  const autoAcceptDispatchPrevented = usePreventAutoAcceptDispatch();

  if (autoAcceptDispatchPrevented) {
    return null;
  }

  return (
    <Badge
      size="small"
      color="primary"
      borderRadius="soft"
      style={{ color: 'var(--color-primary-700)' }}
      hasBorder
    >
      <IconDone />
      {!isMobile && !isTablet && (
        <Trans id="components.workshop-list.auto-accept">Auto-accept</Trans>
      )}
    </Badge>
  );
};

export const usePreventAutoAcceptDispatch = () => {
  const { workflow } = useRequestContext();
  const { article } = useArticleContext();

  const serviceChoiceStepConfig =
    article.step?.step === 'service-choice'
      ? article.step.config
      : workflow?.nodes?.find((node) => 'step' in node && node.step === 'service-choice')?.config;

  const autoAcceptDispatchPrevented =
    article.snapshot.articleActions.some(
      (action) =>
        isCustom(action) ||
        (!!action.customWorkshopPrice && action.customWorkshopPrice.amount !== null)
    ) && !!serviceChoiceStepConfig?.requireWorkshopPrice;

  return !!autoAcceptDispatchPrevented;
};
